<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div v-if="wtdata!==null" class="moduleCard">
            <wondertable :wtID="'groupLog'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'This Group Has No Log'" :defaultDirection="1"
                         :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Group Log'" :burgerMenu="burgermenu"></wondertable>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"

  export default {
    name: 'GroupLogs',
    components: {acheader,acfooter,groupsidebar,wondertable},
    data() {
      return {
        burgermenu: [],
        wids: ["OperationID"],
        wtdata: null,
        wtmethods:{}
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapGroup(this.$route.params.id);

        this.apiCommand([
        {
          Operation: "LicensePool",
          Function: "GetGroupOperationLogs",
          Fields: {
            LicensePoolID: this.sdata.activegroup.LicensePoolID,
            GroupID: this.$route.params.id
          }
        }        
        ]).then(response=>{
          try {
            var cr = JSON.parse(response.CommandResult);
            var data= JSON.parse(cr.returnObjects[0].returnObject);
            for(var entry of data) {
              entry.user=this.buildSimUser(entry.ClientID,entry.Username,entry.EmailAddress,entry.FirstName,entry.LastName,false,true);
              entry.OperationText=this.fixOpText(entry.OperationText);
            }
            this.wtdata=data;
          }
          catch(e) {
            this.popDialog(1, "An unspecified error occurred");
          }
        });

      });
    }
  }
</script>
